<template>
  <div class="pgd-dashboard">
            <v-card-title class="body-2 font-weight-bold">
              DASHBOARD PEGADAIAN
            </v-card-title>
            <div class="dashboard-filters mx-2">
              <div class="dashboard-category-filter">
                <div class="category-filter-label">
                  <v-icon>mdi-shape-outline</v-icon>
                  <div>
                    <span>Kategori Produk</span>
                    <small>Pilih jenis pertanggungan</small>
                  </div>
                </div>
                <div class="category-filter-options">
                <v-btn
                  v-for="row in items.filter"
                  :key="row.id"
                  @click="FilterData(row.id)"
                  class="filter-pill"
                  :class="{ 'filter-pill--active': row.id === form.filter }"
                  depressed
                  >{{ row.id }}
                </v-btn>
                </div>
              </div>
              <div class="dashboard-periods">
                <v-select
                  v-model="form.dashboard_month"
                  :items="items.dashboardMonths"
                  item-text="text"
                  item-value="value"
                  label="Bulan"
                  clearable
                  dense
                  outlined
                  hide-details
                  class="dashboard-period-filter"
                  @change="ApplyDashboardPeriod"
                ></v-select>
                <v-select
                  v-model="form.dashboard_year"
                  :items="dashboardYears"
                  label="Tahun"
                  clearable
                  dense
                  outlined
                  hide-details
                  class="dashboard-period-filter"
                  @change="ApplyDashboardPeriod"
                ></v-select>
              </div>
            </div>
            <!-- <div
              v-if="form.filter === 'PEMBIAYAAN'"
              class="ml-2 mt-2 fourth--text"
            >
              Perhitungan Ratio Klaim 75% dari Total Kontribusi
            </div>
            <div v-else class="ml-2 mt-2 primary--text">
              Perhitungan Ratio Klaim 100% dari Total Kontribusi
            </div> -->
            <div></div>
            <v-progress-linear
              indeterminate
              color="primary"
              v-if="loading.kanwil"
            ></v-progress-linear>
            <div class="dashboard-toolbar mx-2">
              <v-text-field
                v-model="search.product"
                prepend-inner-icon="mdi-magnify"
                placeholder="Cari data produk..."
                outlined
                dense
                hide-details
                class="toolbar-search"
              ></v-text-field>
              <div class="export-actions">
                <v-btn
                  class="export-btn export-btn--primary"
                  depressed
                  @click="ExportDashboardExcel"
                  :loading="loading.export"
                  :disabled="!item.product.length || loading.export"
                >
                  <v-icon left>mdi-download-outline</v-icon>
                  Export Produk
                </v-btn>
                <v-btn
                  class="export-btn export-btn--secondary"
                  depressed
                  @click="ExportKanwilAreaExcel"
                  :loading="loading.exportKanwilArea"
                  :disabled="
                    !item.policybykanwil.length || loading.exportKanwilArea
                  "
                >
                  <v-icon left>mdi-table-arrow-down</v-icon>
                  Export Wilayah
                </v-btn>
              </div>
            </div>
            <v-data-table
              :headers="headers_product"
              :search="search.product"
              :items="item.product"
              dense
              class="elevation-0 modern-data-table"
              :loading="loading.product"
              loading-text="Loading details..."
            >
              <template v-slot:item.stoploss_remaining="{ item }">
                {{ FormatMoney(item.stoploss_remaining) }}
              </template>
              <template v-slot:item.contribution_gross="{ item }">
                {{ FormatMoney(item.contribution_gross) }}
              </template>
              <template v-slot:item.gross_claim="{ item }">
                {{ FormatMoney(item.gross_claim) }}
              </template>
              <template v-slot:item.claim_ratio="{ item }">
                <span
                  :style="{
                    color:
                      CalculatePercentage(
                        item.gross_claim,
                        item.contribution_gross,
                        item.subrogation
                      ).replace(',', '.') > 75
                        ? 'red'
                        : 'green'
                  }"
                >
                  {{
                    CalculatePercentage(
                      item.gross_claim,
                      item.contribution_gross,
                      item.subrogation
                    )
                  }}
                  %
                </span>
              </template>
              <template v-slot:item.subrogation="{ item }">
                {{ FormatMoney(item.subrogation) }}
              </template>
              <template v-slot:item.settled_claim="{ item }">
                {{
                  FormatMoney(
                    (Number(item.gross_claim) || 0) -
                      (Number(item.subrogation) || 0)
                  )
                }}
              </template>

              <!-- Tambahkan subtotal di footer -->
              <template v-slot:body.append>
                <tr class="dashboard-subtotal-row">
                  <td colspan="4" class="font-weight-bold">Subtotal</td>
                  <td class="text-right font-weight-bold">
                    {{ FormatMoney(totalContribution) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ FormatMoney(totalClaim) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ FormatMoney(totalSubrogation) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ FormatMoney(totalClaim - totalSubrogation) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ FormatMoney(totalRemaining) }}
                  </td>
                  <td class="text-right font-weight-bold">
                    {{
                      CalculatePercentage(
                        totalClaim,
                        totalContribution,
                        totalSubrogation
                      )
                    }}%
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-text-field
              v-model="search.kanwil"
              prepend-inner-icon="mdi-magnify"
              placeholder="Cari data wilayah..."
              outlined
              dense
              hide-details
              class="mx-2 table-search"
            ></v-text-field>
            <v-data-table
              :headers="headers_kanwil"
              :items="item.policybykanwil"
              :search="search.kanwil"
              item-key="policy_ano"
              class="elevation-0 modern-data-table"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-page-first',
                lastIcon: 'mdi-page-last',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right'
              }"
              dense
              :loading="loading.list"
              loading-text="Loading... Please wait"
              :single-expand="true"
              :show-expand="false"
              :expanded.sync="expanded"
              :items-per-page="-1"
              @click:row="HandleRowClick"
            >
              <template v-slot:item="props">
                <tr
                  @click="HandleRowClick(props.item)"
                  :class="{
                    'expanded-row': isExpanded(props.item.id),
                    'custom-bg': isExpanded(props.item.id)
                  }"
                >
                  <td
                    v-for="header in props.headers"
                    :key="header.text"
                    :style="{ textAlign: header.align || 'left' }"
                  >
                    <template v-if="header.value === 'stoploss_remaining'">
                      {{ FormatMoney(props.item[header.value])}}
                    </template>
                    <template v-else-if="header.value === 'contribution_gross'">
                      {{ FormatMoney(props.item[header.value]) }}
                    </template>
                    <template v-else-if="header.value === 'gross_claim'">
                      {{ FormatMoney(props.item[header.value]) }}
                    </template>
                    <template v-else-if="header.value === 'claim_ratio'">
                      <span
                        :style="{
                          color:
                            CalculatePercentage(
                              props.item.gross_claim,
                              props.item.contribution_gross,
                              props.item.subrogation
                            ).replace(',', '.') > 75
                              ? 'red'
                              : 'green'
                        }"
                      >
                        {{
                          CalculatePercentage(
                            props.item.gross_claim,
                            props.item.contribution_gross,
                            props.item.subrogation
                          )
                        }}
                        %
                      </span>
                    </template>
                    <template v-else-if="header.value === 'subrogation'">
                      {{ FormatMoney(props.item[header.value]) }}
                    </template>
                    <template v-else-if="header.value === 'settled_claim'">
                      {{
                        FormatMoney(
                          (Number(props.item.gross_claim) || 0) -
                            (Number(props.item.subrogation) || 0)
                        )
                      }}
                    </template>
                    <template v-else>
                      {{ props.item[header.value] }}
                    </template>
                  </td>
                </tr>
                <!-- Expanded content for Kanwil -->
                <tr v-if="isExpanded(props.item.id)">
                  <td :colspan="headers_kanwil.length" class="custom-bg">
                    <v-card flat>
                      <v-card-title class="text-detail"
                        >AREA PADA {{ props.item.description }}</v-card-title
                      >
                      <v-progress-linear
                        indeterminate
                        color="primary"
                        v-if="loading.area"
                      ></v-progress-linear>
                      <v-text-field
                        v-model="search.area"
                        prepend-inner-icon="mdi-magnify"
                        placeholder="Cari area..."
                        outlined
                        dense
                        hide-details
                        class="mx-2 table-search"
                      ></v-text-field>
                      <v-data-table
                        :headers="headers_area"
                        :search="search.area"
                        :items="item.policybyarea"
                        dense
                        class="elevation-0 modern-data-table modern-data-table--nested"
                        :loading="loading.detail"
                        loading-text="Loading details..."
                        :single-expand="true"
                        :show-expand="false"
                        :expanded.sync="expandedArea"
                        @click:row="HandleAreaRowClick"
                      >
                        <template v-slot:item="{ item: areaItem }">
                          <tr
                            @click="HandleAreaRowClick(areaItem)"
                            :class="{
                              'expanded-row-area': isAreaExpanded(areaItem.id),
                              'custom-bg-area': isAreaExpanded(areaItem.id)
                            }"
                          >
                            <td
                              v-for="header in headers_area"
                              :key="header.text"
                              :style="{ textAlign: header.align || 'left' }"
                            >
                              <template v-if="['contribution_gross', 'stoploss_remaining'].includes(header.value)">
                                {{
                                  FormatMoney(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="header.value === 'gross_claim'"
                              >
                                {{
                                  FormatMoney(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="header.value === 'claim_ratio'"
                              >
                                <span
                                  :style="{
                                    color:
                                      CalculatePercentage(
                                        areaItem.gross_claim,
                                        areaItem.contribution_gross,
                                        areaItem.subrogation
                                      ).replace(',', '.') > 75
                                        ? 'red'
                                        : 'green'
                                  }"
                                >
                                  {{
                                    CalculatePercentage(
                                      areaItem.gross_claim,
                                      areaItem.contribution_gross,
                                      areaItem.subrogation
                                    )
                                  }}
                                  %
                                </span>
                              </template>
                              <template
                                v-else-if="header.value === 'subrogation'"
                              >
                                {{
                                  FormatMoney(
                                    areaItem[header.value]
                                  )
                                }}
                              </template>
                              <template
                                v-else-if="header.value === 'settled_claim'"
                              >
                                {{
                                  FormatMoney(
                                    (Number(areaItem.gross_claim) || 0) -
                                      (Number(areaItem.subrogation) || 0)
                                  )
                                }}
                              </template>
                              <template v-else>
                                {{ areaItem[header.value] }}
                              </template>
                            </td>
                          </tr>
                          <!-- Expanded content for Area (Outlet) -->
                          <tr v-if="isAreaExpanded(areaItem.id)">
                            <td
                              :colspan="headers_area.length"
                              class="custom-bg-area"
                            >
                              <v-card flat>
                                <v-card-title class="text-detail-outlet"
                                  >OUTLET PADA
                                  {{ areaItem.description }}</v-card-title
                                >
                                <v-progress-linear
                                  indeterminate
                                  color="orange"
                                  v-if="loading.outlet"
                                ></v-progress-linear>
                                <v-text-field
                                  v-model="search.outlet"
                                  prepend-inner-icon="mdi-magnify"
                                  placeholder="Cari outlet..."
                                  outlined
                                  dense
                                  hide-details
                                  class="mx-2 table-search"
                                ></v-text-field>
                                <v-data-table
                                  :headers="headers_outlet"
                                  :search="search.outlet"
                                  :items="item.policybyoutlet"
                                  dense
                                  class="elevation-0 modern-data-table modern-data-table--nested"
                                  hide-default-footer
                                >
                                  <template v-slot:item.stoploss_remaining="{ item }">
                {{ FormatMoney(item.stoploss_remaining) }}
              </template>
              <template v-slot:item.contribution_gross="{ item }">
                                    {{
                                      FormatMoney(item.contribution_gross)
                                    }}
                                  </template>
                                  <template v-slot:item.gross_claim="{ item }">
                                    {{
                                      FormatMoney(item.gross_claim)
                                    }}
                                  </template>
                                  <template v-slot:item.claim_ratio="{ item }">
                                    <span
                                      :style="{
                                        color:
                                          CalculatePercentage(
                                            item.gross_claim,
                                            item.contribution_gross,
                                            item.subrogation
                                          ).replace(',', '.') > 75
                                            ? 'red'
                                            : 'green'
                                      }"
                                    >
                                      {{
                                        CalculatePercentage(
                                          item.gross_claim,
                                          item.contribution_gross,
                                          item.subrogation
                                        )
                                      }}
                                      %
                                    </span>
                                  </template>
                                  <template
                                    v-slot:item.subrogation="{ item }"
                                  >
                                    {{
                                      FormatMoney(
                                        item.subrogation
                                      )
                                    }}
                                  </template>
                                  <template v-slot:item.settled_claim="{ item }">
                                    {{
                                      FormatMoney(
                                        (Number(item.gross_claim) || 0) -
                                          (Number(item.subrogation) || 0)
                                      )
                                    }}
                                  </template>
                                </v-data-table>
                              </v-card>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snackbar.dialog"
              :color="snackbar.color"
              :timeout="snackbar.timeout"
              rounded="pill"
              bottom
            >
              {{ snackbar.text }}
              <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.dialog = false">Close</v-btn>
              </template>
            </v-snackbar>
  </div>
</template>

<script>
const dashboardHeaders = label => [
  { text: "ID", value: "id", width: "5%" },
  { text: label, value: "description" },
  { text: "TAHUN", value: "year", align: "center", width: "7%" },
  { text: "BULAN", value: "month", align: "center", width: "9%" },
  { text: "TOTAL KONTRIBUSI", value: "contribution_gross", align: "end", width: "10%" },
  { text: "TOTAL KLAIM", value: "gross_claim", align: "end", width: "10%" },
  { text: "TOTAL SUBRO", value: "subrogation", align: "end", width: "10%" },
  { text: "NET KLAIM", value: "settled_claim", align: "end", width: "10%" },
  { text: "SISA SALDO", value: "stoploss_remaining", align: "end", width: "10%" },
  { text: "RATIO KLAIM (%)", value: "claim_ratio", align: "end", width: "10%" }
];

export default {
  name: "AppPgdDashboard",
  data: () => ({
    expanded: [],
    expandedArea: [],
    currentExpandedId: null,
    currentExpandedAreaId: null,
    form: {
      filter: "PEMBIAYAAN",
      dashboard_year: "",
      dashboard_month: ""
    },
    item: {
      product: [],
      policybykanwil: [],
      policybyarea: [],
      policybyoutlet: []
    },
    loading: {
      list: false,
      detail: false,
      kanwil: false,
      area: false,
      outlet: false,
      product: false,
      export: false,
      exportKanwilArea: false
    },
    search: {
      product: "",
      kanwil: "",
      area: "",
      outlet: ""
    },
    items: {
      filter: [
        { id: "PEMBIAYAAN" },
        { id: "KENDARAAN" },
        { id: "KEBAKARAN" },
        { id: "JIWA" }
      ],
      dashboardMonths: [
        { text: "Januari", value: 1 },
        { text: "Februari", value: 2 },
        { text: "Maret", value: 3 },
        { text: "April", value: 4 },
        { text: "Mei", value: 5 },
        { text: "Juni", value: 6 },
        { text: "Juli", value: 7 },
        { text: "Agustus", value: 8 },
        { text: "September", value: 9 },
        { text: "Oktober", value: 10 },
        { text: "November", value: 11 },
        { text: "Desember", value: 12 }
      ]
    },
    headers_product: dashboardHeaders("PRODUK"),
    headers_kanwil: dashboardHeaders("KANWIL"),
    headers_area: dashboardHeaders("AREA"),
    headers_outlet: dashboardHeaders("OUTLET"),
    snackbar: {
      dialog: false,
      color: "success",
      text: "",
      timeout: 3000
    }
  }),
  created() {
    this.GetDashboardProduct();
    this.GetDashboardKanwil();
  },
  computed: {
    dashboardYears() {
      const currentYear = new Date().getFullYear();
      return Array.from({ length: 15 }, (_, index) => currentYear - index);
    },
    totalRemaining() {
      return this.item.product.reduce((sum, item) => sum + Math.round(item.stoploss_remaining * 100), 0) / 100;
    },
    totalContribution() {
      return this.item.product.reduce(
        (sum, item) => sum + Math.round(this.MoneyNumber(item.contribution_gross) * 100),
        0
      ) / 100;
    },
    totalClaim() {
      return this.item.product.reduce(
        (sum, item) => sum + Math.round(this.MoneyNumber(item.gross_claim) * 100),
        0
      ) / 100;
    },
    totalSubrogation() {
      return this.item.product.reduce(
        (sum, item) => sum + Math.round(this.MoneyNumber(item.subrogation) * 100),
        0
      ) / 100;
    }
  },
  methods: {
    FormatMoney(value) {
      return new Intl.NumberFormat("id-ID", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(this.MoneyNumber(value));
    },
    MoneyNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? Math.round(number * 100) / 100 : 0;
    },
    SnackBar(dialog, color, text, timeout) {
      this.snackbar.dialog = dialog;
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.timeout = timeout;
    },
    AppendManualDashboardProduct(productList = []) {
      return Array.isArray(productList) ? productList : [];
    },
    NormalizeDashboardRows(rows = []) {
      return (Array.isArray(rows) ? rows : []).map(row => {
        const monthValue = row.month || this.form.dashboard_month;
        const month = this.items.dashboardMonths.find(
          item => Number(item.value) === Number(monthValue)
        );
        return {
          ...row,
          contribution_gross: this.MoneyNumber(row.contribution_gross ?? row.contribution),
          gross_claim: this.MoneyNumber(row.gross_claim ?? row.total_claim),
          subrogation: this.MoneyNumber(row.subrogation ?? row.total_subrogation),
          settled_claim: this.MoneyNumber(
            this.MoneyNumber(row.gross_claim ?? row.total_claim) -
            this.MoneyNumber(row.subrogation ?? row.total_subrogation)
          ),
          claim_ratio: Number(this.CalculatePercentage(
            this.MoneyNumber(row.gross_claim ?? row.total_claim),
            this.MoneyNumber(row.contribution_gross ?? row.contribution),
            this.MoneyNumber(row.subrogation ?? row.total_subrogation)
          ).replace(",", ".")),
          stoploss_remaining: this.MoneyNumber(row.stoploss_remaining),
          year: row.year || this.form.dashboard_year || "SEMUA",
          month: month ? month.text.toUpperCase() : "SEMUA"
        };
      });
    },
    AppendDashboardPeriod(formData) {
      if (this.form.dashboard_year) {
        formData.append("year", this.form.dashboard_year);
      }
      if (this.form.dashboard_month) {
        formData.append("month", this.form.dashboard_month);
      }
    },
    GetDashboardProduct() {
      const formData = new FormData();
      formData.append("url_type", "product");
      formData.append("branchclient_category", this.form.filter);
      this.AppendDashboardPeriod(formData);
      this.loading.product = true;
      this.$axios
        .post(this.$functions.SafeURL("apiListDashboardPegadaianDWH", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.item.product = this.AppendManualDashboardProduct(
              this.NormalizeDashboardRows(feedback)
            );
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.product = false; });
    },
    GetDashboardKanwil() {
      const formData = new FormData();
      formData.append("url_type", "kanwil");
      formData.append("branchclient_category", this.form.filter);
      this.AppendDashboardPeriod(formData);
      this.loading.kanwil = true;
      this.$axios
        .post(this.$functions.SafeURL("apiListDashboardPegadaianDWH", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.item.policybykanwil = this.NormalizeDashboardRows(feedback);
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.kanwil = false; });
    },
    GetDashboardArea(id) {
      const formData = new FormData();
      formData.append("url_type", "area");
      formData.append("branchclient_kanwilid", id);
      formData.append("branchclient_category", this.form.filter);
      this.AppendDashboardPeriod(formData);
      this.loading.area = true;
      this.$axios
        .post(this.$functions.SafeURL("apiListDashboardPegadaianDWH", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.item.policybyarea = this.NormalizeDashboardRows(feedback);
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.area = false; });
    },
    FetchAreaDataForExport(id) {
      const formData = new FormData();
      formData.append("url_type", "area");
      formData.append("branchclient_kanwilid", id);
      formData.append("branchclient_category", this.form.filter);
      this.AppendDashboardPeriod(formData);
      return this.$axios
        .post(this.$functions.SafeURL("apiListDashboardPegadaianDWH", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (
            feedback.length > 0 &&
            typeof feedback[0].feedback !== "undefined" &&
            feedback[0].feedback !== "Y"
          ) {
            throw new Error(feedback[0].feedback);
          }
          return this.NormalizeDashboardRows(feedback);
        });
    },
    GetDashboardOutlet(id) {
      const formData = new FormData();
      formData.append("url_type", "outlet");
      formData.append("branchclient_areaid", id);
      formData.append("branchclient_category", this.form.filter);
      this.AppendDashboardPeriod(formData);
      this.loading.outlet = true;
      this.$axios
        .post(this.$functions.SafeURL("apiListDashboardPegadaianDWH", ""), formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(response => {
          const feedback = response.data;
          if (feedback.length > 0 && feedback[0].feedback !== "Y") {
            this.SnackBar(true, "error", feedback[0].feedback, 0);
          } else {
            this.item.policybyoutlet = this.NormalizeDashboardRows(feedback);
          }
        })
        .catch(error => this.SnackBar(true, "error", error.message, 3000))
        .finally(() => { this.loading.outlet = false; });
    },
    HandleRowClick(item) {
      if (this.currentExpandedId === item.id) {
        this.currentExpandedId = null;
      } else {
        this.currentExpandedId = item.id;
        this.item.policybyarea = [];
        this.GetDashboardArea(item.id);
      }
    },
    isExpanded(id) {
      return this.currentExpandedId === id;
    },
    HandleAreaRowClick(item) {
      if (this.currentExpandedAreaId === item.id) {
        this.currentExpandedAreaId = null;
        this.item.policybyoutlet = [];
      } else {
        this.currentExpandedAreaId = item.id;
        this.item.policybyoutlet = [];
        this.GetDashboardOutlet(item.id);
      }
    },
    isAreaExpanded(id) {
      return this.currentExpandedAreaId === id;
    },
    DownloadExcel(filename, headers, rows) {
      const escapeHtml = value => {
        if (value === null || value === undefined) return "";
        return String(value)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      };
      const numericColumns = [4, 5, 6, 7];
      const lastColumn = headers.length - 1;
      const buildCell = (value, index, tag, emphasized) => {
        const headerStyle =
          "background-color:#001f48;color:#ffffff;font-weight:bold;";
        const alignment = numericColumns.includes(index)
          ? "text-align:right;"
          : index === lastColumn
          ? "text-align:center;"
          : "text-align:left;";
        const style = `${
          tag === "th" ? headerStyle : ""
        }border:1px solid #e0e0e0;padding:6px 10px;${alignment}${
          emphasized ? "font-weight:bold;" : ""
        }`;
        return `<${tag} style="${style}">${escapeHtml(value)}</${tag}>`;
      };
      const tableHeader = `<tr>${headers
        .map((title, index) => buildCell(title, index, "th", false))
        .join("")}</tr>`;
      const tableRows = rows
        .map(row => {
          const emphasized = row.some(
            value =>
              typeof value === "string" && value.toUpperCase().includes("TOTAL")
          );
          return `<tr>${row
            .map((value, index) => buildCell(value, index, "td", emphasized))
            .join("")}</tr>`;
        })
        .join("");
      const blob = new Blob(
        ["\ufeff" + `<table style="border-collapse:collapse;width:100%;">${tableHeader}${tableRows}</table>`],
        { type: "application/vnd.ms-excel" }
      );
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    ExportDashboardExcel() {
      if (!this.item.product.length) {
        this.SnackBar(true, "error", "Data dashboard tidak tersedia", 3000);
        return;
      }
      this.loading.export = true;
      try {
        const formatNumber = value =>
          this.FormatMoney(Number(value) || 0);
        const headers = this.headers_product.map(header =>
          String(header.text).toUpperCase()
        );
        const rows = this.item.product.map(product => {
          const claim = Number(product.gross_claim) || 0;
          const contribution_gross = Number(product.contribution_gross) || 0;
          const subrogation = Number(product.subrogation) || 0;
          return [
            product.id,
            product.description,
            product.year,
            product.month,
            formatNumber(contribution_gross),
            formatNumber(claim),
            formatNumber(subrogation),
            formatNumber(claim - subrogation),
            formatNumber(product.stoploss_remaining),
            `${this.CalculatePercentage(claim, contribution_gross, subrogation)} %`
          ];
        });
        rows.push([
          "TOTAL",
          "PRODUK",
          this.form.dashboard_year || "SEMUA",
          this.NormalizeDashboardRows([{}])[0].month,
          formatNumber(this.totalContribution),
          formatNumber(this.totalClaim),
          formatNumber(this.totalSubrogation),
          formatNumber(this.totalClaim - this.totalSubrogation),
          formatNumber(this.totalRemaining),
          `${this.CalculatePercentage(
            this.totalClaim,
            this.totalContribution,
            this.totalSubrogation
          )} %`
        ]);
        const today = this.$functions.Today
          ? this.$functions.Today()
          : new Date().toISOString().slice(0, 10);
        this.DownloadExcel(
          `dashboard-pegadaian-${today.replace(/\//g, "-")}.xls`,
          headers,
          rows
        );
      } catch (error) {
        this.SnackBar(true, "error", error.message, 3000);
      } finally {
        this.loading.export = false;
      }
    },
    async ExportKanwilAreaExcel() {
      if (!this.item.policybykanwil.length) {
        this.SnackBar(true, "error", "Data kanwil tidak tersedia", 3000);
        return;
      }
      this.loading.exportKanwilArea = true;
      try {
        const details = await Promise.all(
          this.item.policybykanwil.map(async kanwil => ({
            kanwil,
            areas: await this.FetchAreaDataForExport(kanwil.id)
          }))
        );
        const headers = [
          "KANWIL",
          "AREA",
          "TAHUN",
          "BULAN",
          "CONTRIBUTION",
          "CLAIM",
          "SUBRO",
          "NET KLAIM",
          "LOSS RATIO (%)"
        ];
        const formatNumber = value =>
          this.FormatMoney(Number(value) || 0);
        const overall = { contribution_gross: 0, claim: 0, subrogation: 0 };
        const rows = [];
        details.forEach(({ kanwil, areas }) => {
          (Array.isArray(areas) ? areas : [])
            .filter(area => area.description)
            .forEach((area, index) => {
              const contribution_gross = Number(area.contribution_gross) || 0;
              const claim = Number(area.gross_claim) || 0;
              const subrogation = Number(area.subrogation) || 0;
              rows.push([
                index === 0 ? kanwil.description : "",
                area.description,
                area.year,
                area.month,
                formatNumber(contribution_gross),
                formatNumber(claim),
                formatNumber(subrogation),
                formatNumber(claim - subrogation),
                `${this.CalculatePercentage(claim, contribution_gross, subrogation)} %`
              ]);
            });
          const contribution_gross = Number(kanwil.contribution_gross) || 0;
          const claim = Number(kanwil.gross_claim) || 0;
          const subrogation = Number(kanwil.subrogation) || 0;
          overall.contribution_gross += contribution_gross;
          overall.claim += claim;
          overall.subrogation += subrogation;
          rows.push([
            kanwil.description,
            "TOTAL",
            kanwil.year,
            kanwil.month,
            formatNumber(contribution_gross),
            formatNumber(claim),
            formatNumber(subrogation),
            formatNumber(claim - subrogation),
            `${this.CalculatePercentage(claim, contribution_gross, subrogation)} %`
          ]);
        });
        rows.push([
          "TOTAL",
          "KESELURUHAN",
          this.form.dashboard_year || "SEMUA",
          this.NormalizeDashboardRows([{}])[0].month,
          formatNumber(overall.contribution_gross),
          formatNumber(overall.claim),
          formatNumber(overall.subrogation),
          formatNumber(overall.claim - overall.subrogation),
          `${this.CalculatePercentage(
            overall.claim,
            overall.contribution_gross,
            overall.subrogation
          )} %`
        ]);
        const today = this.$functions.Today
          ? this.$functions.Today()
          : new Date().toISOString().slice(0, 10);
        this.DownloadExcel(
          `dashboard-kanwil-area-${today.replace(/\//g, "-")}.xls`,
          headers,
          rows
        );
      } catch (error) {
        this.SnackBar(true, "error", error.message || error, 3000);
      } finally {
        this.loading.exportKanwilArea = false;
      }
    },
    CalculatePercentage(claim, contribution_gross, subro) {
      if (!contribution_gross || contribution_gross === 0) return "0,00";
      return (((claim - subro) / contribution_gross) * 100).toFixed(2).replace(".", ",");
    },
    FilterData(id) {
      this.form.filter = id;
      this.ApplyDashboardPeriod();
    },
    ApplyDashboardPeriod() {
      this.currentExpandedId = null;
      this.currentExpandedAreaId = null;
      this.item.policybyarea = [];
      this.item.policybyoutlet = [];
      this.GetDashboardProduct();
      this.GetDashboardKanwil();
    }
  }
};
</script>

<!--
  Vuetify merender sebagian elemen (v-btn, v-select, dan v-data-table) di dalam
  komponen anaknya sendiri. Style ini sengaja tidak scoped agar class tampilan
  dashboard tetap menjangkau elemen hasil render Vuetify.
-->
<style>
.pgd-dashboard .dashboard-filters { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; padding: 14px 16px; border: 1px solid #e1e6ef; border-radius: 14px; background: #fff; box-shadow: 0 7px 22px rgba(24, 36, 76, 0.05); }
.pgd-dashboard .dashboard-category-filter { display: flex; flex: 1 1 600px; align-items: center; gap: 18px; order: 1; min-width: 0; }
.pgd-dashboard .category-filter-label { display: flex; flex: 0 0 auto; align-items: center; gap: 10px; padding-right: 18px; border-right: 1px solid #e4e8f0; color: #26345f; }
.pgd-dashboard .category-filter-label > .v-icon { width: 36px; height: 36px; border-radius: 10px; background: #fff3c7; color: #30427d; font-size: 20px; }
.pgd-dashboard .category-filter-label div { display: flex; flex-direction: column; line-height: 1.25; }
.pgd-dashboard .category-filter-label span { font-size: 13px; font-weight: 700; }
.pgd-dashboard .category-filter-label small { margin-top: 2px; color: #8992a8; font-size: 10px; white-space: nowrap; }
.pgd-dashboard .category-filter-options { display: flex; flex-wrap: wrap; align-items: center; gap: 7px; min-width: 0; }
.pgd-dashboard .dashboard-periods { display: flex; flex: 0 1 340px; gap: 10px; order: 3; }
.pgd-dashboard .dashboard-period-filter { flex: 1 1 160px; min-width: 145px; }
.pgd-dashboard .dashboard-toolbar { display: flex; justify-content: flex-end; align-items: center; gap: 10px; margin: 18px 8px 0; padding: 14px 16px; border: 1px solid #e1e6ef; border-bottom: 0; border-radius: 14px 14px 0 0; background: #fff; }
.pgd-dashboard .toolbar-search { width: 100%; max-width: 360px; }
.pgd-dashboard .export-actions { display: flex; flex: 0 0 auto; gap: 8px; margin-left: auto; }
.pgd-dashboard .export-btn { height: 42px !important; border-radius: 10px !important; padding: 0 16px !important; text-transform: none !important; font-size: 13px !important; font-weight: 600; letter-spacing: 0; transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease; }
.pgd-dashboard .export-btn:not(.v-btn--disabled):hover { transform: translateY(-1px); }
.pgd-dashboard .export-btn--primary { background: #202f68 !important; color: #fff !important; box-shadow: 0 7px 16px rgba(32, 47, 104, 0.2); }
.pgd-dashboard .export-btn--primary:not(.v-btn--disabled):hover { background: #182653 !important; box-shadow: 0 9px 20px rgba(32, 47, 104, 0.28); }
.pgd-dashboard .export-btn--secondary { border: 1px solid #d5dbea; background: #fff !important; color: #28365f !important; }
.pgd-dashboard .export-btn--secondary:not(.v-btn--disabled):hover { border-color: #aeb9d1; background: #f7f9fc !important; }
.pgd-dashboard .export-btn .v-icon { font-size: 18px; }
.pgd-dashboard .filter-pill { position: relative; min-width: auto !important; height: 38px !important; padding: 0 15px !important; border: 1px solid #e0e5ee; border-radius: 9px !important; color: #45516f !important; background: #f7f8fb !important; font-size: 12px !important; font-weight: 600; letter-spacing: 0.015em; text-transform: none; box-shadow: none !important; transition: color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease !important; }
.pgd-dashboard .filter-pill:not(.filter-pill--active):hover { border-color: #b8c2d7; background: #f0f3f8 !important; color: #26345f !important; transform: translateY(-1px); }
.pgd-dashboard .filter-pill--active { padding-left: 29px !important; border-color: #26386f !important; background: #26386f !important; color: #fff !important; box-shadow: 0 7px 16px rgba(38, 56, 111, 0.2) !important; }
.pgd-dashboard .filter-pill--active::before { position: absolute; left: 13px; width: 7px; height: 7px; border-radius: 50%; background: #f1bd26; box-shadow: 0 0 0 3px rgba(241, 189, 38, 0.18); content: ""; }
.pgd-dashboard .expanded-row-area td { background-color: #ff8800 !important; color: #fff !important; font-weight: bold !important; }
.pgd-dashboard .custom-bg-area { padding: 0 2px 2px !important; background-color: #ff8800 !important; }
.pgd-dashboard .expanded-row-area:hover td { background-color: #ff8800 !important; }
.pgd-dashboard .expanded-row-area td span { color: #fff !important; }
.pgd-dashboard .expanded-row td { background-color: #001f48 !important; color: #fff !important; font-weight: bold !important; }
.pgd-dashboard .custom-bg { background-color: #001f48 !important; padding: 0 2px 2px !important; }
.pgd-dashboard .expanded-row:hover td { background-color: #001f48 !important; }
.pgd-dashboard .expanded-row td span { color: #fff !important; }
.pgd-dashboard .text-detail { color: #001f48; padding: 5px 10px; }
.pgd-dashboard .text-detail-outlet { color: #ff8800; padding: 5px 10px; }
.pgd-dashboard .v-data-table tbody tr { cursor: pointer; }
.pgd-dashboard .table-search { max-width: 360px; margin-top: 18px !important; margin-right: 8px !important; margin-bottom: 10px !important; margin-left: auto !important; }
.pgd-dashboard .table-search .v-input__slot,
.pgd-dashboard .toolbar-search .v-input__slot { min-height: 42px; border-radius: 10px; background: #fff; transition: box-shadow 0.2s ease; }
.pgd-dashboard .table-search fieldset,
.pgd-dashboard .toolbar-search fieldset { border-color: #d5dbea; transition: border-color 0.2s ease; }
.pgd-dashboard .table-search.v-input--is-focused fieldset,
.pgd-dashboard .toolbar-search.v-input--is-focused fieldset { border-width: 1px; border-color: #334783; }
.pgd-dashboard .table-search.v-input--is-focused .v-input__slot,
.pgd-dashboard .toolbar-search.v-input--is-focused .v-input__slot { box-shadow: 0 0 0 3px rgba(51, 71, 131, 0.09); }
.pgd-dashboard .table-search .v-icon,
.pgd-dashboard .toolbar-search .v-icon { color: #7180a4; font-size: 20px; }
.pgd-dashboard .table-search input::placeholder,
.pgd-dashboard .toolbar-search input::placeholder { color: #8790a6; opacity: 1; }
.pgd-dashboard .table-search .v-input__slot::before,
.pgd-dashboard .table-search .v-input__slot::after,
.pgd-dashboard .toolbar-search .v-input__slot::before,
.pgd-dashboard .toolbar-search .v-input__slot::after { display: none; }
.pgd-dashboard .modern-data-table { margin: 0 8px 22px; overflow: hidden; border: 1px solid #e1e6ef; border-radius: 14px; background: #fff; box-shadow: 0 10px 28px rgba(24, 36, 76, 0.07) !important; }
.pgd-dashboard .dashboard-toolbar + .modern-data-table { border-top-left-radius: 0; border-top-right-radius: 0; }
.pgd-dashboard .modern-data-table .v-data-table__wrapper { scrollbar-width: thin; scrollbar-color: #a8afba #f0f2f5; }
.pgd-dashboard .modern-data-table .v-data-table__wrapper::-webkit-scrollbar { width: 8px; height: 8px; }
.pgd-dashboard .modern-data-table .v-data-table__wrapper::-webkit-scrollbar-track { background: #f0f2f5; }
.pgd-dashboard .modern-data-table .v-data-table__wrapper::-webkit-scrollbar-thumb { border: 2px solid #f0f2f5; border-radius: 999px; background: #9299a5; }
.pgd-dashboard .modern-data-table thead tr { background: #edf3f8; }
.pgd-dashboard .modern-data-table thead th { height: 50px; padding: 0 18px; border-bottom: 1px solid #d8e0eb !important; background: #edf3f8; color: #25345f !important; font-size: 12px; font-weight: 700; letter-spacing: 0.055em; line-height: 1.35; text-transform: uppercase; white-space: nowrap; }
.pgd-dashboard .modern-data-table thead th .v-icon { color: #7180a4 !important; font-size: 18px; }
.pgd-dashboard .modern-data-table tbody td { height: 50px; padding: 0 18px; border-bottom: 1px solid #edf0f5 !important; color: #34405f; font-size: 13px; white-space: nowrap; transition: background-color 0.2s ease; }
.pgd-dashboard .modern-data-table tbody tr:not(.expanded-row):not(.expanded-row-area):hover td { background: #f8faff !important; }
.pgd-dashboard .modern-data-table .dashboard-subtotal-row td { background: #f5f7fb; color: #1d2d59; }
.pgd-dashboard .modern-data-table .v-data-footer { min-height: 64px; border-top: 0; color: #5e687f; }
.pgd-dashboard .modern-data-table .v-data-footer__select .v-select { margin-left: 8px; }
.pgd-dashboard .modern-data-table .v-data-footer .v-btn { color: #25345f; }
.pgd-dashboard .modern-data-table--nested { margin: 4px 8px 12px; border-radius: 10px; box-shadow: none !important; }
@media (max-width: 1100px) { .pgd-dashboard .dashboard-category-filter { flex-basis: 100%; } }
@media (max-width: 600px) {
  .pgd-dashboard .dashboard-filters { padding: 12px; }
  .pgd-dashboard .dashboard-category-filter { flex-direction: column; align-items: stretch; gap: 12px; }
  .pgd-dashboard .category-filter-label { padding-right: 0; padding-bottom: 10px; border-right: 0; border-bottom: 1px solid #e4e8f0; }
  .pgd-dashboard .category-filter-options { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .pgd-dashboard .filter-pill { width: 100%; padding-right: 8px !important; padding-left: 8px !important; }
  .pgd-dashboard .filter-pill--active { padding-left: 23px !important; }
  .pgd-dashboard .filter-pill--active::before { left: 10px; }
  .pgd-dashboard .dashboard-periods { flex-direction: column; flex-basis: 100%; margin-left: 0; order: 2; }
  .pgd-dashboard .dashboard-period-filter { flex-basis: auto; width: 100%; }
  .pgd-dashboard .dashboard-toolbar { flex-wrap: wrap; margin-right: 4px; margin-left: 4px; padding: 12px; }
  .pgd-dashboard .export-actions { width: 100%; margin-left: 0; }
  .pgd-dashboard .export-btn { flex: 1 1 0; padding: 0 10px !important; }
  .pgd-dashboard .toolbar-search,
  .pgd-dashboard .table-search { max-width: none; }
  .pgd-dashboard .modern-data-table { margin-right: 4px; margin-left: 4px; border-radius: 10px; }
  .pgd-dashboard .modern-data-table thead th,
  .pgd-dashboard .modern-data-table tbody td { padding-right: 14px; padding-left: 14px; }
}
</style>


